import React from 'react';
import { RelationshipsInfinityIcon } from './relationships-infinity-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_2 } from './topic-card-shared';

import relationshipsPersonImage from './relationships-person.webp';

interface RelationshipsTopicCardProps {
  title: string;
  className?: string;
}

export const RelationshipsTopicCard: React.FC<RelationshipsTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute left-0 top-7 h-[37px] w-[80px] shrink-0 sm:left-2 sm:top-8 sm:h-[55.336px] sm:w-[120.508px]">
          <RelationshipsInfinityIcon fill={TOPIC_CARD_ICON_2} className="h-full w-full" />
        </div>
        <img
          src={relationshipsPersonImage}
          alt=""
          className="relative z-10 ml-5 aspect-square h-[100px] w-[100px] shrink-0 object-contain object-center sm:ml-8 sm:h-[150px] sm:w-[150px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
